export default __webpack_public_path__ + "static/international-metric-mobile-e2138d86254057514fa12fc1c6a4b0f2.svg";